import React from 'react';

import CustomButton from "components/CustomButton";

import ActionButtonContentContainer from "./ActionButtonContentContainer";

function ValidateButton({onClick}) {
    return (
        <CustomButton onClick={onClick} variant={'outlined'} color={'green'}>
            <ActionButtonContentContainer>
                <svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5'
                     strokeLinecap='round' strokeLinejoin='round'>
                    <polyline points='20 6 9 17 4 12'/>
                </svg>
                Valider
            </ActionButtonContentContainer>
        </CustomButton>
    );
}

export default ValidateButton;
